<template>
  <!-- マスター管理 -->
  <div id="MasterMaint">
    <div id="container">
      <masterNavi v-if="isMaint" v-bind:pageid='"MasterMaint"'></masterNavi>
      <div class="labelTitle lable">マスター管理</div>
      <template  v-if="isMaint">
        <div class="labelTitle lable">住所マスター</div>
        <ul class="link-area">
          <li>
            <b-field class="file">
              <b-upload v-model="targetFile" @input="uploadAddress">
                <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div>住所マスター<br>アップロード</div></div></a>
              </b-upload>
            </b-field>
          </li>
          <li>
            <a><div class="buttonArea" @click="downloadAddress"><b-icon icon="file-download-outline" size="is-large"/><div>住所マスター<br>ダウンロード</div></div></a>
          </li>
        </ul>
        <div class="labelTitle lable">支店マスター</div>
        <ul class="link-area">
          <li>
            <b-field class="file">
              <b-upload v-model="targetFile" @input="uploadOffice">
                <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div>支店マスター<br>アップロード</div></div></a>
              </b-upload>
            </b-field>
          </li>
          <li>
            <a><div class="buttonArea" @click="downloadOffice"><b-icon icon="file-download-outline" size="is-large"/><div>支店マスター<br>ダウンロード</div></div></a>
          </li>
        </ul>
        <div class="labelTitle lable">得意先マスター</div>
        <ul class="link-area">
          <li>
            <b-field class="file">
              <b-upload v-model="targetFile" @input="uploadCustomer">
                <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div>得意先マスター<br>アップロード</div></div></a>
              </b-upload>
            </b-field>
          </li>
          <li>
            <a><div class="buttonArea" @click="downloadCustomer"><b-icon icon="file-download-outline" size="is-large"/><div>得意先マスター<br>ダウンロード</div></div></a>
          </li>
        </ul>
        <div class="labelTitle lable">従業員マスター</div>
        <ul class="link-area">
          <li>
            <b-field class="file">
              <b-upload v-model="targetFile" @input="uploadStaff">
                <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div>従業員マスター<br>アップロード</div></div></a>
              </b-upload>
            </b-field>
          </li>
          <li>
            <a><div class="buttonArea" @click="downloadStaff"><b-icon icon="file-download-outline" size="is-large"/><div>従業員マスター<br>ダウンロード</div></div></a>
          </li>
        </ul>
        <div class="labelTitle lable">品目マスター</div>
        <ul class="link-area">
          <li>
            <b-field class="file">
              <b-upload v-model="targetFile" @input="uploadItem">
                <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div>品目マスター<br>アップロード</div></div></a>
              </b-upload>
            </b-field>
          </li>
          <li>
            <a><div class="buttonArea" @click="downloadItem"><b-icon icon="file-download-outline" size="is-large"/><div>品目マスター<br>ダウンロード</div></div></a>
          </li>
        </ul>
      </template>
      <div class="labelTitle lable">患者コードマスター</div>
      <ul class="link-area">
        <li>
          <b-field class="file">
            <b-upload v-model="targetFile" @input="uploadPatientCode">
              <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div>患者コードマスター<br>アップロード</div></div></a>
            </b-upload>
          </b-field>
        </li>
        <li>
          <a><div class="buttonArea" @click="downloadPatientCode"><b-icon icon="file-download-outline" size="is-large"/><div>患者コードマスター<br>ダウンロード</div></div></a>
        </li>
        <li>
          <b-field class="file">
            <b-upload v-model="targetFile" @input="uploadTransferPatientCode">
              <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div>再開患者コード<br>マスターアップロード</div></div></a>
            </b-upload>
          </b-field>
        </li>
        <li>
          <a><div class="buttonArea" @click="downloadTransferPatientCode"><b-icon icon="file-download-outline" size="is-large"/><div>再開患者コード<br>マスターダウンロード</div></div></a>
        </li>
      </ul>
      <div class="labelTitle lable">使用明細</div>
      <ul class="link-area">
        <li>
          <b-field class="file">
            <b-upload v-model="targetFile" @input="uploadUsageDetails">
              <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div>使用明細<br>アップロード</div></div></a>
            </b-upload>
          </b-field>
        </li>
      </ul>
      <div class="labelTitle lable">患者動態マスター</div>
      <ul class="link-area">
        <li>
          <a><div class="buttonArea" @click="downloadKanjaDotai(true)"><b-icon icon="file-download-outline" size="is-large"/><div>（新規）患者動態<br>ダウンロード</div></div></a>
        </li>
        <li>
          <a><div class="buttonArea" @click="downloadKanjaDotai(false)"><b-icon icon="file-download" size="is-large"/><div>（更新）患者動態<br>ダウンロード</div></div></a>
        </li>
      </ul>
      <div class="labelTitle lable">得意先担当マスター</div>
      <ul class="link-area">
        <li>
          <b-field class="file">
            <b-upload v-model="targetFile" @input="uploadCustomerStaffRelation">
              <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div>得意先担当マスター<br>アップロード</div></div></a>
            </b-upload>
          </b-field>
        </li>
        <li>
          <a><div class="buttonArea" @click="downloadCustomerStaffRelation"><b-icon icon="file-download-outline" size="is-large"/><div>得意先担当マスター<br>ダウンロード</div></div></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
import {role} from "@/components/mock/base/const.js";

export default {
  name: "MasterMaint",
  props: {
    isMaint:{default:true}
  },
  methods: {
    uploadAddress: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.uploadMaintenanceAddressMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadOffice: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenanceBranchMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadCustomer: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenanceCustomerMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadStaff: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenanceEmployeeMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadItem: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenanceItemMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadPatientCode: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenancePatientCodeMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadTransferPatientCode: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenanceTransferPatientCodeMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadUsageDetails: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadUsageDetailsMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      );
    },
    uploadCustomerStaffRelation: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadCustomerStaffRelationPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      );
    },
    downloadAddress: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceAddressMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadOffice: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceBranchMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadCustomer: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceCustomerMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadStaff: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceEmployeeMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadItem: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceItemMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadPatientCode: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenancePatientCodeMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadTransferPatientCode: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceTransferPatientCodeMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadKanjaDotai: function(newFlag){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceKanjaDotaiMasterPOST({
            body:{newFlag:newFlag}
          })
        },
        this.errorDownload
      );
    },
    downloadCustomerStaffRelation: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadCustomerStaffRelationPOST()
        },
        this.errorDownload
      );
    },
    successSave: function(result){
      this.targetFile = null;
      this.showSuccess(result);
    },
    errorSave: function(result){
      this.targetFile = null;
      this.showErrorMessage(result);
    },
    errorDownload: function(result){
      this.showErrorMessage(result);
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var isAdmin = roleId == role.role_admin;
    return {
      targetFile: {},
      isAdmin
    };
  },
  components: {
    masterNavi: naviBar,
  }
};
</script>

<style lang="scss" >
ul.link-area {
    width: 100%;
    min-height: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
ul.link-area>li {
    margin:10px;
}
a .buttonArea {
    display: flex;
    align-items:center;
    padding: 10px;
    height: 100px;
    border-radius: 5px;
    background: linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
    );
    background: -moz-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
    );
    background: -webkit-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
    );
    color:whitesmoke;
}
a .buttonArea:hover{
    color:whitesmoke;
}
a .buttonArea div {
    margin-left:10px;
    padding-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/master/master/MasterMaint.vue